import React, { useContext } from 'react'
import {
    NewStyledSavedSearchesViewAll,
    StyledNoSavedSearches,
    StyledYourSavedSearchesItem,
    StyledYourSavedSearchesModalTitle,
    StyledYourSavedSearchListing,
} from './your-saved-searches.styles'
import { SavedSearchQueryContext } from '../../../contexts/saved-search-context'
import { YourSavedSearchItem } from './your-saved-search-item'
import { YourSavedSearchesModalProps } from './your-saved-searches-modal'

const MAX_SAVED_SEARCH_PER_MODAL = 6

export const YourSavedSearchListing = ({ handleHideModal }: YourSavedSearchesModalProps) => {
    const { savedSearchList } = useContext(SavedSearchQueryContext)
    const savedSearchesPreview = savedSearchList.slice(0, MAX_SAVED_SEARCH_PER_MODAL)

    return (
        <StyledYourSavedSearchListing>
            <StyledYourSavedSearchesModalTitle as="h3">Your saved searches</StyledYourSavedSearchesModalTitle>
            {savedSearchList?.length > 0 ? (
                <>
                    {savedSearchesPreview.map((savedSearch, index) => (
                        <StyledYourSavedSearchesItem key={savedSearch.name + index}>
                            <YourSavedSearchItem
                                key={savedSearch.name}
                                savedSearch={savedSearch}
                                handleHideModal={handleHideModal}
                            />
                        </StyledYourSavedSearchesItem>
                    ))}
                    {savedSearchList?.length > MAX_SAVED_SEARCH_PER_MODAL ? (
                        <NewStyledSavedSearchesViewAll
                            displayType="secondary"
                            text={'View all saved searches'}
                            type="button"
                            url={{ href: '/secure/saved-searches', rel: 'external noopener noreferrer' }}
                        />
                    ) : null}
                </>
            ) : (
                <StyledNoSavedSearches>{"Sorry, you don't have any saved searches"}</StyledNoSavedSearches>
            )}
        </StyledYourSavedSearchListing>
    )
}
